import GetInstallationAddress from "../../../../contents/docs/self-host/_snippets/get-installation-address";
import * as React from 'react';
export default {
  GetInstallationAddress,
  React
};